import type { IExternalSourceResponseBody } from '../../../types/response/IExternalSourceResponseBody';
import { SimpleArtist } from './SimpleArtist';
import { SimpleMember } from './SimpleMember';

export class LocationExternalSource {
  constructor(
    private readonly _tweetId: string | null,
    private readonly _author: string | null,
    private readonly _authorProfileUrl: string | null,
    private readonly _authoredDate: string | null,
    private readonly _text: string | null,
    private readonly _tweetUrl: string,
    private readonly _imageUrls: string[] | null,
    private readonly _hashTags: string[] | null,
    private readonly _externalSourceId: string | null,
    private readonly _externalSourceUrl: string,
    private readonly _externalSourceType: string,
    private readonly _artist: SimpleArtist,
    private readonly _member: SimpleMember
  ) {}

  get tweetId(): string | null {
    return this._tweetId;
  }

  get author(): string | null {
    return this._author;
  }

  get authorProfileUrl(): string | null {
    return this._authorProfileUrl;
  }

  get authoredDate(): string | null {
    return this._authoredDate;
  }

  get text(): string | null {
    return this._text;
  }

  get tweetUrl(): string {
    return this._tweetUrl;
  }

  get imageUrls(): string[] | null {
    return this._imageUrls;
  }

  get hashTags(): string[] | null {
    return this._hashTags;
  }

  get externalSourceId(): string | null {
    return this._externalSourceId;
  }

  get externalSourceUrl(): string {
    return this._externalSourceUrl;
  }

  get externalSourceType(): string {
    return this._externalSourceType;
  }

  get artist(): SimpleArtist {
    return this._artist;
  }

  get member(): SimpleMember {
    return this._member;
  }

  public baseImageUrl(): string {
    return this._imageUrls && this._imageUrls.length > 0 ? this._imageUrls[0].replace("'", '') : '';
  }

  public getArtistMemberNames(): string {
    return this._member.name;
  }

  static fromResponse(response: IExternalSourceResponseBody): LocationExternalSource {
    return new LocationExternalSource(
      response.tweetId,
      response.author,
      response.authorProfileUrl,
      response.authoredDate,
      response.text,
      response.tweetUrl,
      response.imageUrls,
      response.hashTags,
      response.externalSourceId,
      response.externalSourceUrl,
      response.externalSourceType,
      SimpleArtist.fromResponse(response.artist),
      SimpleMember.fromResponse(response.member)
    );
  }
}
